var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export function getMonth(date) {
    return monthNames[date.getMonth()];
}
export function getDayMonth(date) {
    return "".concat(date.getDate(), " ").concat(getMonth(date));
}
